import React from 'react'
import IMLeadTable from './common/IMLeadTable';
import alldata from "../database/All_leads"

const LeadToSheet = () => {
    let allRow = alldata;
    // allRow.length = 10;

    let heads = [
        { displayName: "SN", key: "RN" , key2:"UNIQUE_QUERY_ID"},
        { displayName: "DATE_R", key: "DATE_R" , key2:"QUERY_TIME"},
        { displayName: "QUERY_ID", key: "QUERY_ID" , key2:""},
        { displayName: "SENDERNAME", key: "SENDERNAME" , key2:"SENDER_NAME"},
        { displayName: "SENDEREMAIL", key: "SENDEREMAIL" , key2:"SENDER_EMAIL"},
        { displayName: "GLUSR_USR_COMPANYNAME", key: "GLUSR_USR_COMPANYNAME" , key2:"SENDER_COMPANY"},
        { displayName: "MOB", key: "MOB" , key2:"SENDER_MOBILE"},
        { displayName: "ENQ_CITY", key: "ENQ_CITY" , key2:"SENDER_CITY"},
        { displayName: "ENQ_STATE", key: "ENQ_STATE" , key2:"SENDER_STATE"},
        { displayName: "PRODUCT_NAME", key: "PRODUCT_NAME" , key2:"QUERY_PRODUCT_NAME"},
        { displayName: "MOBILE_ALT", key: "MOBILE_ALT", key2:"SENDER_PHONE_ALT" }
    ]

    return (
        <div>
            <div>
                <span>Total: {allRow.length}</span>
                <span>Total Unique: {allRow.length}</span>
                <spa></spa>
            </div>
            <IMLeadTable heads={heads} data={allRow}/>
        </div>
    )
}

export default LeadToSheet;
